var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-fade-transition",
        [
          _vm.selectedCounts > 0
            ? _c(
                "v-sheet",
                {
                  staticClass: "d-flex pa-2",
                  style: {
                    position: "fixed",
                    width: _vm.$vuetify.breakpoint.smAndDown ? "80%" : "40%",
                    left: _vm.$vuetify.breakpoint.smAndDown ? "16px" : "30%",
                    bottom: "16px",
                    "z-index": 199,
                    "align-items": "center",
                    "justify-content": _vm.$vuetify.breakpoint.smAndDown
                      ? "flex-start"
                      : "space-between",
                  },
                  attrs: { color: "transparent" },
                },
                [
                  _c(
                    "v-chip",
                    {
                      staticClass: "elevation-8",
                      staticStyle: { "margin-right": "24px" },
                      attrs: { label: "", close: "", color: "primary" },
                      on: { "click:close": _vm.clearAllEntries },
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.selectionBannerContent),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _vm.selectedCounts == 1
                        ? [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  top: "",
                                  color: _vm.errorFoldseekBtn
                                    ? "error"
                                    : "primary",
                                  value: _vm.errorFoldseekBtn,
                                  "open-on-click": false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "mr-3 elevation-8",
                                                  attrs: {
                                                    color: _vm.errorFoldseekBtn
                                                      ? "error"
                                                      : "primary",
                                                    fab: "",
                                                    loading: _vm.loading,
                                                  },
                                                  on: {
                                                    click: _vm.sendToFoldseek,
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.isSelectionComplex
                                                      ? _vm.$MDI.Multimer
                                                      : _vm.$MDI.Monomer
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1998953923
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.toFoldseekContent)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  top: "",
                                  color: _vm.errorFoldDiscoBtn
                                    ? "error"
                                    : "#eca800",
                                  value: _vm.errorFoldDiscoBtn,
                                  "open-on-click": false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "elevation-8 fold-disco-btn",
                                                  class: {
                                                    "btn-disabled":
                                                      _vm.isSelectionUnableToFetch,
                                                  },
                                                  staticStyle: {
                                                    color: "#fff",
                                                  },
                                                  attrs: {
                                                    fab: "",
                                                    color: _vm.errorFoldDiscoBtn
                                                      ? "error"
                                                      : "#eca800",
                                                    loading: _vm.loading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.isSelectionUnableToFetch
                                                        ? () => {}
                                                        : _vm.sendToFoldDisco()
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v(_vm._s(_vm.$MDI.Motif)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3784284718
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.toFoldDiscoContent),
                                  },
                                }),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  top: "",
                                  color: "primary",
                                  "open-on-click": false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "mr-3 elevation-8",
                                                  attrs: {
                                                    color: _vm.includeQuery
                                                      ? "primary"
                                                      : "secondary",
                                                    fab: "",
                                                    small: "",
                                                    loading: _vm.loading,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.toggleIncludeQuery,
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.includeQuery
                                                      ? _vm.$MDI.IncludeQuery
                                                      : _vm.$MDI.ExcludeQuery
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  616601441
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "Click to " +
                                      _vm._s(
                                        _vm.includeQuery ? "exclude" : "include"
                                      ) +
                                      " query structure"
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  top: "",
                                  color: _vm.errorFoldMasonBtn
                                    ? "error"
                                    : "primary",
                                  value: _vm.errorFoldMasonBtn,
                                  "open-on-click": false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "elevation-8",
                                                  attrs: {
                                                    fab: "",
                                                    color: _vm.errorFoldMasonBtn
                                                      ? "error"
                                                      : "primary",
                                                    loading: _vm.loading,
                                                  },
                                                  on: {
                                                    click: _vm.sendToFoldMason,
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v(_vm._s(_vm.$MDI.Wall)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2819855275
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.toFoldMasonContent),
                                  },
                                }),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", width: "480px" },
              model: {
                value: _vm.loading,
                callback: function ($$v) {
                  _vm.loading = $$v
                },
                expression: "loading",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { loading: _vm.loading } },
                [
                  _c(
                    "template",
                    { slot: "progress" },
                    [
                      _c("v-progress-linear", {
                        attrs: { indeterminate: "", color: "primary" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-title", [_vm._v("Please Wait...!")]),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _vm._v(
                      "\n                    We're processing your request. It may take upto a minute...\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", text: "" },
                          on: { click: _vm.cancelJob },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }